import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { SecretRecord } from "../SecretRecord";

export const getQueryKey = (secretName?: string) => {
  if (secretName === undefined) {
    return ["secretRecord"];
  }

  return ["secretRecord", secretName];
};

export function useSecretRecord(secretName: string, orgId: string) {
  const { secretService } = useDomainServices();

  return useQuery<SecretRecord, Error>({
    queryKey: getQueryKey(secretName),
    queryFn: async ({ signal }) => {
      return secretService.getSecretByName(secretName, orgId, {
        abortSignal: signal,
      });
    },
  });
}
